<template>
  <div v-if="value?.length">
    <div
      v-for="(description, index) in value"
      :key="description"
      class="my-6 w-40 truncate text-headline"
      ref="descriptionsRef"
      v-tooltip="{
        content: description,
        onShow: () => isDescriptionTruncated(index),
      }"
    >
      {{ description }}
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import { ref } from "vue";

const { value } = defineProps<{ value?: string[] }>();
const descriptionsRef = ref<HTMLElement[]>([]);

const isDescriptionTruncated = (index: number) => {
  const { scrollWidth, clientWidth } = descriptionsRef.value?.[index] || {};
  return scrollWidth > clientWidth;
};
</script>
